<template>
  <div class="tourist">
    <heads></heads>
    <div class="container">
      <div class="add-tourist">
        <span class="withdrawal" @click="handleAddBtn">添加游客</span>
        <el-dialog class="my-dialog" :visible.sync="dialogFormVisible">
          <div slot="title">
            <div class="title-text">请{{isAdd ? '填写' : '修改'}}游客信息</div>
            <el-switch v-model="form.isdefault"
                       active-text="默认游客信息"
                       inactive-text="新游客信息"
                       class="title-switch">
            </el-switch>
          </div>
          <el-form>
            <el-form-item label="游客真实姓名" :label-width="formLabelWidth">
              <el-input v-model="form.name" autocomplete="off" placeholder="请输入游客真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="游客手机号码" :label-width="formLabelWidth">
              <el-input v-model="form.phone" autocomplete="off" placeholder="请输入游客手机号码"></el-input>
            </el-form-item>
            <el-form-item class="bottom" label="游客证件类别" :label-width="formLabelWidth">
              <el-radio-group v-model="form.id_types">
                <el-radio label="0">身份证</el-radio>
                <el-radio label="1">护 照</el-radio>
                <el-radio label="2">其 他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="游客证件号码" :label-width="formLabelWidth">
              <el-input @blur="handleIdNumberInput(form.id_card)" v-model="form.id_card" autocomplete="off" placeholder="请输入游客的身份证"></el-input>
            </el-form-item>
            <el-form-item class="bottom" prop="date" label="游客出生日期" :label-width="formLabelWidth">
              <el-date-picker type="date" placeholder="选择出生日期" v-model="form.birthday" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="bottom right" label="游客性别" :label-width="formLabelWidth">
              <el-radio-group v-model="form.gender">
                <el-radio label="M">男</el-radio>
                <el-radio label="F">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleAddTourist">{{isAdd ? '添 加' : '修改'}}</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="content" v-loading="loading">
        <div class="leaderlist" v-for="(item,index) in showList" :key="index">
          <div class="top">
            <div class="name">
              <i class="fa fa-user-circle-o" aria-hidden="true"></i><span>{{item.contactName}}</span><i class="fa" :class="[item.gender === 0 ? 'fa-mars':'fa-venus']" aria-hidden="true"></i>
            </div>
            <div class="phone"><i class="fa fa-mobile" aria-hidden="true"></i>{{item.mobile}}</div>
          </div>
          <div class="middle">
            <div class="id-card">
              <i class="fa fa-id-card-o" aria-hidden="true"></i> {{idType(item.idType)}}：{{item.idNumber}}
            </div>
            <div class="birthday">
              出生日期：{{item.birthday}}
            </div>
          </div>
          <div class="infoitem">
            <el-button class="pull-right m-left" size="small" type="danger" plain @click.native="handleDeleteClick(trueIndex(index))">删除</el-button>
            <el-button class="pull-right m-left" size="small" type="success" plain @click.native="handleEditClick(trueIndex(index))">编辑</el-button>
          </div>
        </div>
      </div>
      <div class="my-pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @prev-click="prevClick"
          @next-click="nextClick"
          :page-size="10"
          :page-count="pageCount"

          :current-page="leaderlist.currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import qs from 'qs'
import axios from "axios";
export default {
  name: "tourist",
  data() {
    return {
      dialogFormVisible: false,
      isAdd:true,
      form: {
        id_types:'0',
        name: '',
        phone:'',
        id_card:'',
        birthday:'',
        gender:'M',
        isdefault:false
      },
      formLabelWidth: '100px',
      leaderlist:{
        page:0,
        total:0,
        totalPage:0,
        currentPage:1,
        list:[]
      },

      loading : false
    };
  },
  components: {
    heads,
    homeFoots,
  },
  computed: {
    pageCount(){
      return this.leaderlist.totalPage > this.leaderlist.page ? this.leaderlist.page + 1 : this.leaderlist.page;
    },
    idType(){
      return function(num){
        switch (num){
          case 0 : return '身份证';
            break;
          case 1 : return '护照';
            break;
          case 2 : return '其他';
            break;
          default: break;
        }
      }
    },
    nav() {
      return this.$route.params.id;
    },
    showList(){
      const currentPage = this.leaderlist.currentPage;
      return this.leaderlist.list.slice( (currentPage -1) * 10 , currentPage * 10);
    },
    trueIndex(){
      return function(index){
        return index + 10 * (this.leaderlist.currentPage -1);
      }
    }
  },
  methods: {
    handleIdNumberInput(idNumber){
      // console.log(idNumber);
      const IdCardNumberReg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
      if(IdCardNumberReg.test(idNumber) && this.form.id_types.indexOf('0') !== -1){
        const birth = idNumber.substring(6,10)+"-"+idNumber.substring(10,12)+"-"+idNumber.substring(12,14);
        this.form.birthday = birth;
      }
    },
    prevClick(){
      if(this.leaderlist.currentPage > 1) {
        this.leaderlist.currentPage -= 1;
      }
    },
    nextClick(){
      const currentPage = this.leaderlist.currentPage;
      const page = this.leaderlist.page;
      const totalpage = this.leaderlist.totalPage;
      if(currentPage < totalpage){
        // this.leaderlist.currentPage += 1;
        if(this.leaderlist.currentPage -1 === page && page < totalpage){
          this.loading = true;
          this.requestTouristMessage();
        }
      }
    },
    handleCurrentChange(val){
      const currentPage = this.leaderlist.currentPage;
      const page = this.leaderlist.page;
      const totalpage = this.leaderlist.totalPage;
      this.leaderlist.currentPage = val;
      if(this.leaderlist.currentPage -1 >= page && page < totalpage){
        this.loading = true;
        this.requestTouristMessage();
      }
    },
    requestTouristMessage(){
      axios
        .get(`/favoriteContacts/getFavoriteContacts.jhtml`, {
          params: {
            pageNumber: this.leaderlist.page + 1,
            pageSize: 10
          }
        })
        .then(res => {
          if (res.data.success) {
            const data = res.data.returnValue;
            this.leaderlist.total = data.total;
            this.leaderlist.totalPage = data.totalPages;
            if(data.content.length !== 0){
              this.leaderlist.list.push(...data.content);
              this.leaderlist.page += 1;
            }
          }
          this.loading = false;
        });
    },
    getNav(index) {
     this.$router.push({ path: `/userindex/${index}` });
    },
    handleCancel(){ //并清空填写，收回弹框
      this.emptyForm()
      this.dialogFormVisible = false
    },
    changeServerMessage(method,message) {
      const that = this ;
      const baseUrl = '/favoriteContacts/';
      let url = '';
      let params = null;
      let IdCardNumberReg = null;
      let IsValid = null;
      let PhoneNumberReg = null;
      let IsValphone = null;

      switch (method) {
        case 'post':
          url = baseUrl + 'addFavoriteContacts.jhtml';
          IdCardNumberReg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
          IsValid = IdCardNumberReg.test(message.idNumber);
          PhoneNumberReg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
          IsValphone = PhoneNumberReg.test(message.mobile);

          if( IsValphone && (message.idType != 0 || IsValid) ){
            axios
              .post(url, qs.stringify(message))
              .then(res => {
                if(res.data.success){
                  that.leaderlist.list.push(message);
                  that.$message({
                    type: 'success',
                    message: '游客信息添加成功!',
                    duration: 1500
                  });
                  that.dialogFormVisible = false;
                }
              })
          }else {
            that.$message({
              type: 'error',
              message: '请输入正确身份证号码或者手机号码!',
              duration: 1000
            });
          }
          
          break;
        case 'put':
          // 编辑信息
          url = baseUrl + 'updateFavoriteContacts.jhtml';
          IdCardNumberReg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
          IsValid = IdCardNumberReg.test(message.idNumber);
          PhoneNumberReg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
          IsValphone = PhoneNumberReg.test(message.mobile);
          params = message;
          const index = that.form.index;
          const dataItem = that.leaderlist.list[index];
          params.id = dataItem.id;

          if( IsValphone && (message.idType != 0 || IsValid) ){
            axios
            .post(url,qs.stringify(params))
            .then(res => {
              if(res.data.success){
                //查询该修改成功的游客信息，并更新渲染
                url = baseUrl + 'findFavoriteContacts.jhtml';
                params = {
                  id: dataItem.id
                }
                axios
                  .get(url,{
                    params:params
                  })
                  .then(res => {
                    if(res.data.success){
                      const item = res.data.returnValue;
                      that.leaderlist.list[index].birthday = item.birthday;
                      that.leaderlist.list[index].contactName = item.contactName;
                      that.leaderlist.list[index].idNumber = item.idNumber;
                      that.leaderlist.list[index].idType = item.idType;
                      that.leaderlist.list[index].isdefault = item.isdefault;
                      that.leaderlist.list[index].mobile = item.mobile;
                      that.leaderlist.list[index].gender = item.gender;

                      this.$message({
                        type: 'info',
                        message: '游客信息修改成功!',
                        duration: 1500
                      });

                      that.dialogFormVisible = false;
                    }
                  })
              }
            });
          }else {
            that.$message({
              type: 'error',
              message: '请输入正确的游客证件或者手机号码!',
              duration: 1000
            });
          }
          break;
        case 'delete':
          url = baseUrl + '/deleteFavoriteContacts.jhtml';
          params = {
            id:message.id
          }
          axios
            .get(url,{
              params:params
            })
            .then(res => {
              if(res.data.success){
                const index = message.index;
                that.leaderlist.list.splice(index,index + 1);

                this.$message({
                   type: 'info',
                   message: '游客信息删除成功!',
                   duration: 1500
                });
              }
            })
          break;
        default :
          break;
      }
    },
    handleAddTourist(){//提交信息，并清空填写，最后收回弹框
      const message = {
        contactName: this.form.name,
        gender: this.form.gender.indexOf('M') !== -1 ? 0 : 1,
        birthday: this.form.birthday,
        mobile: this.form.phone,
        idType: this.form.id_types,
        idNumber: this.form.id_card,
        isdefault: this.form.isdefault ? 1 : 0
      }
      if(this.isAdd){ //新增游客信息
        let isAll = true;
        // const form = this.form;
        const form_value = Object.values(message);
        for(let item of form_value){
          if(item.length === 0){
            isAll = false;
            this.$message({
              type: 'error',
              message: '缺少必填信息',
              duration: 1500
            });
            break;
          }
        }
        if(isAll){//全部信息填写完毕,往服务器添加信息
          this.changeServerMessage('post',message);
        }
      }
      else{ //更新游客信息
        this.changeServerMessage('put',message);
      }
    },
    emptyForm(){
      this.form={
        name: '',
        phone:'',
        id_card:'',
        birthday:'',
        gender:'M',
        id_types:'0',
        isdefault:false
      }
    },
    handleEditClick(index){ //监听列表中的编辑点击事件
      this.isAdd = false
      const message = this.leaderlist.list[index]
      this.form = {
        name: message.contactName,
        phone: message.mobile,
        id_card: message.idNumber,
        birthday: message.birthday,
        gender: message.gender ? 'F' : 'M',
        id_types: message.idType + '',
        isdefault : Boolean(message.isdefault),
        index: index
      }
      this.dialogFormVisible = true
    },
    handleAddBtn(){
      this.isAdd = true
      this.emptyForm();
      this.dialogFormVisible = true;
    },
    handleDeleteClick(index){
      this.$confirm('此操作将永久删除该游客信息, 是否继续?', '提示', { //打开警示信息弹框
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // const id = this.leaderlist.list[index].id
        const message = {
          id: this.leaderlist.list[index].id,
          index : index
        }
        this.changeServerMessage('delete',message)
      })
    }
  },
  mounted() {},
  created() {
    this.loading = true;
    this.requestTouristMessage();
  }
};
</script>

<style scoped>
.tourist {
  width: 100%;
  height: 100%;

  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 10px;

  min-height: 500px;
}
.my-dialog .title-text,
.my-dialog .title-switch {
  display: inline-block;
}
.my-dialog .title-switch {
  float: right;
  padding-right: 70px;
  /*font-size: 16px;*/
}
.add-tourist{
  width: 100%;
  padding-bottom: 10px;
  /*position: relative;*/
}
.add-tourist .withdrawal{
  display: inline-block;
  font-size: 12px;
  width: 90px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
  background: #007741;
  color: #ffffff;
  border-radius: 4px;
  /*margin-left: 30px;*/
}
.add-tourist .withdrawal:hover{
  background: #069e5a;
}
.add-tourist .bottom{
  display: inline-block;
}
.add-tourist .bottom.right{
  padding-left: 20px;
}
.content{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  min-height: 300px;
}
.leaderlist{
  cursor: pointer;
  width: 45%;
  height: 120px;
  padding: 20px;
  box-shadow: 0px 0px 6px #c7c6c6;
  border-radius: 2px;
  margin-bottom: 20px;
}
.top {
  display: flex;
  align-items: center;
  position: relative;
}
.top .name > span{
  padding: 0 8px;
}
.top .phone{
  position: absolute;
  right: 0;
}
.middle{
  display: flex;
  align-items: center;
  color: #777;
  padding-top: 15px;

  position: relative;
}
.middle .birthday{
  position: absolute;
  right: 0;
}
.infoitem .pull-right{
  margin-left: 12px;
}
.left-img{
    width: 80px;
    height: 80px;
    border-radius: 100%;
}
.right-info{
    height: 50px;
    line-height: 30px;
    margin-left: 20px;
    padding-left: 20px;
    border-left: 1px solid #999999;
}
.name{
    font-weight: bold;
    font-size: 17px;
}
.fa-mars{
    color: #0e79b1;
}
.evaluate{
    display: flex;
}
.evaluate>span{
    font-size: 15px;
    color: #666666;
     line-height: 20px;
}
.evaluate>span:nth-child(1){
   padding-right: 10px;

    }
.evaluate>span:nth-child(2){
      padding-left: 10px;
    border-left: 1px solid #999999;

    }
    .infoitem{
        margin-top: 20px;
        color: #666666;
    }
    .fa-venus{
        color: #ff79b4;
        margin-left: 6px;
    }

.my-pagination{
  padding: 20px 0;
  display: flex;
  justify-content: space-evenly;
}
</style>



// WEBPACK FOOTER //
// src/components/userview/tourist.vue